import React, { memo } from 'react';
import styled from 'styled-components';
import { StyledJourneyModalFooter } from './styled-journey-side-modal';

const JourneySideModalFooter = ({ children }) => (
  <StyledJourneyModalFooter>{children}</StyledJourneyModalFooter>
);

export default memo(JourneySideModalFooter);
